<template>
  <div class="admin-panel-container">
    <h2>{{ userRole === 'admin' ? 'Panou Administrator' : 'Panou Coordonator' }}</h2>
    
    <ManageEvents 
      ref="manageEventsList"
      @edit-event="handleSelectEvent" 
    />

    <CreateEvent 
      :event-data="eventToEdit" 
      @operation-complete="handleOperationComplete" 
    />
    
    <UserList v-if="userRole === 'admin'" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'; // <-- MODIFICAT: Am adăugat onMounted
import CreateEvent from './CreateEvent.vue';
import UserList from './UserList.vue';
import ManageEvents from './ManageEvents.vue';

const eventToEdit = ref(null);
const manageEventsList = ref(null);

// --- MODIFICARE: Adăugăm logica de verificare a rolului ---
const userRole = ref('');

onMounted(() => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      userRole.value = userData.role;
    }
  } catch (e) {
    console.error("Eroare la citirea rolului în AdminPanel:", e);
  }
});
// --- SFÂRȘIT MODIFICARE ---

const handleSelectEvent = (event) => {
  eventToEdit.value = event;
};

const handleOperationComplete = () => {
  eventToEdit.value = null;
  if (manageEventsList.value) {
    manageEventsList.value.refresh();
  }
};
</script>

<style scoped>
/* Stilurile rămân neschimbate */
.admin-panel-container {
  margin-top: 30px; 
  padding: 20px;
  border: 2px solid #0E3035; 
  border-radius: 10px;
  background-color: #f0f3f5;
}
.admin-panel-container h2 {
  color: #0E3035; 
  margin-top: 0;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 10px;
}
</style>